import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const PHONE = '14074563086';

const WhatsAppButton = () => {
  const { language } = useLanguage();
  
  const greetings = {
    en: 'Hello Revs Vibes, I would like to inquire about your services.',
    es: 'Hola Revs Vibes, me gustaría consultar sobre sus servicios.',
    pt: 'Olá Revs Vibes, gostaria de consultar sobre seus serviços.',
    fr: 'Bonjour Revs Vibes, je souhaiterais me renseigner sur vos services.',
    it: 'Ciao Revs Vibes, vorrei informarmi sui vostri servizi.'
  };

  const url = `https://wa.me/${PHONE}?text=${encodeURIComponent(greetings[language] || greetings.en)}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-btn"
      aria-label="Chat on WhatsApp"
      className="floating-btn fixed bottom-6 left-6 z-50 w-14 h-14 rounded-full flex items-center justify-center transition-all duration-300"
      style={{ background: '#25D366' }}
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.502 1.128 6.748 3.046 9.386L1.054 31.37l6.18-1.962A15.91 15.91 0 0016.004 32C24.826 32 32 24.822 32 16.004 32 7.176 24.826 0 16.004 0zm9.32 22.618c-.39 1.1-2.292 2.1-3.152 2.17-.86.074-1.67.388-5.626-1.172-4.76-1.878-7.77-6.79-8.004-7.106-.234-.316-1.912-2.544-1.912-4.854 0-2.31 1.21-3.448 1.64-3.918.43-.47.938-.588 1.25-.588.312 0 .624.002.898.016.288.014.674-.11 1.054.804.39.938 1.328 3.232 1.446 3.466.118.234.196.508.04.82-.156.312-.234.508-.47.782-.234.274-.492.612-.704.822-.234.234-.478.488-.206.958.274.47 1.216 2.006 2.612 3.248 1.794 1.594 3.306 2.088 3.776 2.322.47.234.742.196 1.016-.118.274-.312 1.172-1.368 1.484-1.838.312-.47.624-.39 1.054-.234.43.156 2.726 1.286 3.196 1.52.47.234.782.352.898.546.118.196.118 1.132-.272 2.232z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
